import { render, staticRenderFns } from "./DelegationDecisionForm.vue?vue&type=template&id=fc682522&scoped=true&"
import script from "./DelegationDecisionForm.vue?vue&type=script&lang=js&"
export * from "./DelegationDecisionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc682522",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc682522')) {
      api.createRecord('fc682522', component.options)
    } else {
      api.reload('fc682522', component.options)
    }
    module.hot.accept("./DelegationDecisionForm.vue?vue&type=template&id=fc682522&scoped=true&", function () {
      api.rerender('fc682522', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Delegation/DelegationDecisionForm.vue"
export default component.exports